import React from 'react';

import { Input, Select } from 'components/Misc/Form';
import { useGradeStudentStore } from 'store/grade/useGradeStudentStore';

const Search = () => {
	// Use grade student store
	const [search, onSearch] = useGradeStudentStore(state => [state.search, state.onSearch]);

	return (
		<div className="p-4 flex items-end gap-4 rounded-lg bg-white dark:bg-neutral-800 transition-colors">
			<Input
				type="text"
				name="name"
				placeholder="Vārds, Uzvārds"
				value={search.name}
				onChange={onSearch}
			/>

			<Select
				name="status"
				placeholder="Studenta statuss"
				value={search.status}
				onChange={onSearch}
				options={[
					{ value: 'active', name: 'Aktīvs' },
					{ value: 'suspended', name: 'Ierobežots' },
					{ value: 'blocked', name: 'Bloķēts' }
				]}
			/>

			<Select
				name="state"
				placeholder="Klases statuss"
				value={search.state}
				onChange={onSearch}
				options={[
					{ value: 'assigned', name: 'Pievienots' },
					{ value: 'active', name: 'Aktīvs' },
					{ value: 'finished', name: 'Pabeidzis' },
					{ value: 'removed', name: 'Atskaitīts' },
					{ value: 'graduated', name: 'Absolvējis' },
				]}
			/>
		</div>
	);
};

export default Search;
